import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconGear } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { showSettingsSubToolbar } from '../../../toolbox/actions.web';
/**
 * An abstract implementation of a button for accessing settings.
 */
class SettingsButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.Settings';
        this.icon = IconGear;
        this.label = 'toolbar.Settings';
        this.tooltip = 'toolbar.Settings';
    }
    _isToggled() {
        return this.props.isSettingsVisible;
    }
    /**
     * Handles clicking / pressing the button, and opens the appropriate dialog.
     *
     * @protected
     * @returns {void}
     */
    _handleClick(event) {
        const { dispatch, isSettingsVisible } = this.props;
        event?.stopPropagation();
        sendAnalytics(createToolbarEvent('settings'));
        dispatch(showSettingsSubToolbar(!isSettingsVisible));
    }
}
SettingsButton.defaultProps = {
    ...AbstractButton.defaultProps,
    customClass: 'settingsButton',
};
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    return {
        isSettingsVisible: state['features/toolbox'].settingsVisible,
    };
};
export default translate(connect(mapStateToProps)(SettingsButton));
